<template>
  <hr class="custom-gray-divider">
</template>
<style lang="scss" scoped>
  .custom-gray-divider {
    border: $hr-gray-divider;
    border-width: 1px 0 0 0;
  }
</style>
